import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    meals: [],
    notifications: [],
    pizza_gallery: [],
    chicken_gallery: [],
    allpizzas_gallery: [],
    settings: []
  },
  getters: {
    allMeals: (state) => state.meals,
    allNotifications: (state) => state.notifications,
    allGalleryPizzas: (state) => state.pizza_gallery,
    allGalleryChicken: (state) => state.chicken_gallery,
    allGalleryAllPizzas: (state) => state.allpizzas_gallery,
    allSettings: (state) => state.settings,
  },
  mutations: {
    GET_MEALS: (state, meals) => {
			state.meals = meals;
		},
    GET_NOTIFICATIONS: (state, notifications) => {
			state.notifications = notifications;
    },
    GET_GALLERY_PIZZAS: (state, pizza_gallery) => {
			state.pizza_gallery = pizza_gallery;
    },
    GET_GALLERY_CHICKEN: (state, chicken_gallery) => {
			state.chicken_gallery = chicken_gallery;
    },
    GET_GALLERY_ALLPIZZAS: (state, allpizzas_gallery) => {
      state.allpizzas_gallery = allpizzas_gallery;
    },
    GET_SETTINGS: (state, settings) => {
			state.settings = settings;
		},
  },
  actions: {
    getMeals({ commit }) {
			axios.get("http://backend.taberna.bunny-haven.xyz/meals").then((response) => {
				commit('GET_MEALS', response.data)
			});
    },
    getGalleryPizzas({ commit }) {
			axios.get("http://backend.taberna.bunny-haven.xyz/gallery/1").then((response) => {
				commit('GET_GALLERY_PIZZAS', response.data[0].images)
			});
    },
    getGalleryChicken({ commit }) {
			axios.get("http://backend.taberna.bunny-haven.xyz/gallery/2").then((response) => {
				commit('GET_GALLERY_CHICKEN', response.data[0].images)
			});
		},
    getGalleryAllPizzas({ commit }) {
      axios.get("http://backend.taberna.bunny-haven.xyz/gallery/3").then((response) => {
        commit('GET_GALLERY_ALLPIZZAS', response.data[0].images)
      });
    },
    getNotifications({ commit }) {
			axios.get("http://backend.taberna.bunny-haven.xyz/notifications").then((response) => {
				commit('GET_NOTIFICATIONS', response.data)
			});
    },
    getSettings({ commit }) {
			axios.get("http://backend.taberna.bunny-haven.xyz/settings").then((response) => {
				commit('GET_SETTINGS', response.data)
			});
		},
  },
  modules: {
  }
})
